<!-- Enhanced Error Display -->
<div class="error-toast" *ngIf="loginError.length > 0">
  <mat-icon class="error-icon">error_outline</mat-icon>
  <span>{{loginError}}</span>
  <button class="close-error" (click)="loginError = ''">
    <mat-icon>close</mat-icon>
  </button>
</div>

<!-- Clean Background System -->
<div class="background-wrapper">
  <div class="fitness-background">
    <div class="brand-overlay">
      <h1 class="brand-title">NEAT Nutrition and Fitness</h1>
      <p class="brand-tagline">Transform Your Life, One Step at a Time</p>
    </div>
  </div>
  
  <div class="login-container">
    <!-- Enhanced Login Card -->
    <div class="login-card-wrapper" *ngIf="loginflow">
      <mat-card class="login-card">
        <!-- Premium Header -->
        <div class="header">
          <div class="back-button" *ngIf="isDisplayCompaniesForm" (click)="onLoginBack()">
            <mat-icon>arrow_back</mat-icon>
          </div>
          <div class="brand-section">
            <div class="logo-container">
              <div class="logo-icon">
                <mat-icon>fitness_center</mat-icon>
              </div>
            </div>
            <h1 class="brand-title">Welcome to NEAT</h1>
            <p class="brand-subtitle">Your fitness journey starts here</p>
          </div>
          <div class="progress-indicator" *ngIf="isDisplayCompaniesForm">
            <div class="progress-step completed"></div>
            <div class="progress-step active"></div>
          </div>
        </div>

        <!-- Enhanced Form Content -->
        <div class="signin-content">
          <!-- Step 1: Username Entry -->
          <form [formGroup]="formUsername" (ngSubmit)="onUserNameSubmit()" *ngIf="!isDisplayCompaniesForm && !isCompanyDomain" class="auth-form">
            <div class="form-header">
              <h2 class="form-title">Sign In</h2>
              <p class="form-description">Enter your username to get started</p>
            </div>
            
            <div class="input-group">
              <mat-form-field class="premium-input" appearance="outline">
                <mat-icon matPrefix class="input-icon">person_outline</mat-icon>
                <input matInput placeholder="Enter your username" formControlName="userName" required>
                <mat-error *ngIf="isFieldUsernameInvalid('userName')">Username is required</mat-error>
              </mat-form-field>
              
              <div class="error-container" *ngIf="invalidUserName">
                <mat-icon class="error-icon">error_outline</mat-icon>
                <span class="error-text">Invalid username. Please check and try again.</span>
              </div>
            </div>

            <button mat-raised-button type="submit" class="primary-btn continue-btn">
              <span>Continue</span>
              <mat-icon class="btn-icon">arrow_forward</mat-icon>
            </button>
          </form>

          <!-- Step 2: Company Selection & Login -->
          <form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="isDisplayCompaniesForm && !isCompanyDomain" class="auth-form">
            <div class="form-header">
              <h2 class="form-title">Complete Sign In</h2>
              <p class="form-description">Select your company and enter your password</p>
            </div>
            
            <div class="input-group">
              <mat-form-field class="premium-input" appearance="outline">
                <mat-icon matPrefix class="input-icon">person_outline</mat-icon>
                <input matInput placeholder="Username" formControlName="userName" required autocomplete="off" readonly>
                <mat-error *ngIf="isFieldInvalid('userName')">Username is required</mat-error>
              </mat-form-field>

              <mat-form-field class="premium-input" appearance="outline">
                <mat-icon matPrefix class="input-icon">business</mat-icon>
                <mat-select [formControl]="companySelected" placeholder="Select your company" [compareWith]="compareObjects">
                  <mat-option *ngFor="let data of companiesList" [value]="data.id" (click)="onSelectCompany(data.id)">
                    <div class="company-option">
                      <span class="company-name">{{data.name}}</span>
                    </div>
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="premium-input" appearance="outline">
                <mat-icon matPrefix class="input-icon">lock_outline</mat-icon>
                <input matInput type="password" placeholder="Enter your password" formControlName="password" required>
                <mat-error *ngIf="isFieldInvalid('password')">Password is required</mat-error>
              </mat-form-field>
              
              <div class="error-container" *ngIf="invalidLogins">
                <mat-icon class="error-icon">error_outline</mat-icon>
                <span class="error-text">Invalid credentials. Please check and try again.</span>
              </div>
            </div>

            <button mat-raised-button type="submit" class="primary-btn">
              <span>Sign In</span>
              <mat-icon class="btn-icon">login</mat-icon>
            </button>
          </form>

          <!-- Step 3: Company Domain Login -->
          <form [formGroup]="formCompanyDomain" *ngIf="isCompanyDomain" (ngSubmit)="onCompanyLogin()" class="auth-form">
            <div class="form-header">
              <h2 class="form-title">Company Sign In</h2>
              <p class="form-description">Enter your credentials to access your account</p>
            </div>
            
            <div class="input-group">
              <mat-form-field class="premium-input" appearance="outline">
                <mat-icon matPrefix class="input-icon">person_outline</mat-icon>
                <input matInput placeholder="Enter your username" formControlName="userName" required autocomplete="off">
                <mat-error *ngIf="isFieldInvalid('userName')">Username is required</mat-error>
              </mat-form-field>

              <mat-form-field class="premium-input" appearance="outline">
                <mat-icon matPrefix class="input-icon">lock_outline</mat-icon>
                <input matInput type="password" placeholder="Enter your password" formControlName="password" required>
                <mat-error *ngIf="isFieldInvalid('password')">Password is required</mat-error>
              </mat-form-field>
              
              <div class="error-container" *ngIf="invalidLogins">
                <mat-icon class="error-icon">error_outline</mat-icon>
                <span class="error-text">Invalid credentials. Please check and try again.</span>
              </div>
            </div>

            <button mat-raised-button type="submit" class="primary-btn">
              <span>Sign In</span>
              <mat-icon class="btn-icon">login</mat-icon>
            </button>
          </form>

          <!-- Forgot Password Link -->
          <div class="forgot-password-section">
            <button class="forgot-password-btn" (click)="forgetPWD()">
              <mat-icon>help_outline</mat-icon>
              <span>Forgot your password?</span>
            </button>
          </div>
        </div>

        <!-- Enhanced Social Login Section -->
        <div class="divider-section">
          <div class="divider-line"></div>
          <span class="divider-text">or continue with</span>
          <div class="divider-line"></div>
        </div>

        <div class="social-login-section social-icons-row">
          <button class="social-icon-btn google-btn" (click)="loginWithGoogle()">
            <img src="/assets/google.jpg" alt="Google" class="social-icon" />
          </button>
          
          <button class="social-icon-btn apple-btn" (click)="loginWithApple()">
            <img src="/assets/apple.png" alt="Apple" class="social-icon" />
          </button>
          
          <button class="social-icon-btn facebook-btn" (click)="loginWithFacebook()">
            <img src="/assets/fb.ico" alt="Facebook" class="social-icon" />
          </button>
        </div>

        <!-- Enhanced Signup Section -->
        <div class="signup-section">
          <div class="signup-divider"></div>
          <p class="signup-text">
            New to NEAT? 
            <button class="signup-btn" (click)="goToSignup()">
              <span>Create an account</span>
              <mat-icon>arrow_forward</mat-icon>
            </button>
          </p>
        </div>
      </mat-card>
    </div>

    <!-- Enhanced Forgot Password Card -->
    <div class="login-card-wrapper" *ngIf="!loginflow">
      <mat-card class="login-card forgot-password-card">
        <div class="back-navigation">
          <button class="back-nav-btn" (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>
            <span>Back to Sign In</span>
          </button>
        </div>
        
        <div class="forgot-password-content">
          <div class="forgot-header">
            <div class="forgot-icon">
              <mat-icon>lock_reset</mat-icon>
            </div>
            <h2 class="forgot-title">Reset Password</h2>
            <p class="forgot-description">Enter your email address and we'll send you a link to reset your password</p>
          </div>
          
          <form [formGroup]="forgetPWDform" (ngSubmit)="onForgetSubmit()" class="forgot-form">
            <div class="input-group">
              <mat-form-field class="premium-input" appearance="outline">
                <mat-icon matPrefix class="input-icon">email</mat-icon>
                <input matInput placeholder="Enter your email address" formControlName="email" required type="email">
                <mat-error *ngIf="isFieldInvalid('email')">Please enter a valid email address</mat-error>
              </mat-form-field>
            </div>
            
            <button mat-raised-button type="submit" class="primary-btn">
              <span>Send Reset Link</span>
              <mat-icon class="btn-icon">send</mat-icon>
            </button>
          </form>
        </div>
      </mat-card>
    </div>
  </div>
</div>